import AnnotationRecordingInfo from './AnnotationRecordingInfo';

export default AnnotationRecordingInfo;



// WEBPACK FOOTER //
// ./src/views/pages/Annotation/container/AnnotationRecordingInfo/index.js